import React, { useState } from "react";
import { Modal, Button, Switch } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const InsuranceTermsModal = ({ open, onClose, onAccept }) => {
  const [language, setLanguage] = useState("english");

  const englishContent = {
    title: "AlfaMall Muhaffiz Takaful by JGI - WTO",
    subtitle: "Basic Fact Sheet",
    greeting: "Dear Participant,",
    intro:
      "Selecting a takaful plan is an important decision and we thank you for your selection. As part of our commitment to ensure that you fully understand the risks and the benefits of your selection, please note the following details for your understanding;",
    description:
      "AlfaMall Muhaffiz Takaful by JGI – WTO is a Shariah Compliant Takaful plan that provides all risk coverage against covering any unforeseen and sudden physical loss or damage to the items covered (PS5, smartwatches, pods, and smart phones). This Takaful plan provides comprehensive coverage beyond screen damage. For PS5 and Pods, accidental or uncertainty-based damages, including IC damage, are covered. However, damages due to warranty-based issues, mechanical failure, design/manufacturer defects, user negligence, or workmanship defects are excluded.",
    keyPoints: [
      "For avoidance of doubt, this membership is a pure Takaful product which is being distributed by Bank Alfalah Limited but is solely the product of Takaful Company. This is not a banking product and Bank Alfalah Limited shall not be held liable, in any manner, whatsoever, in connection with the performance of such products or any loss suffered by the customer resulting from Takaful Company's processing and/or repudiation of claim under the plan.",
      "I acknowledge and authorize the sharing of my demographic and personal details with the Takaful Company for processing purposes.",
      "I understand that there is no investment involved in this plan and the membership tenor is for 1 year only.",
      "I understand that maintaining sufficient funds for deduction at the time of sale in BAFL Account is solely my responsibility for membership issuance.",
      "The Free Look Period under this plan is of 14 days from the date of membership documents receipt in which the membership can be cancelled and a full refund shall be made to the customer.",
      "You may cancel your policy at any time; however, no contribution shall be refunded after 14 days from the contribution deduction; for cancellation you may contact 111 225 111 or mark cancellation via Alfa.",
      "Claim processing is the sole responsibility of Takaful Company. Bank Alfalah Limited, in its role as the Distributor will facilitate the claim submission process. However, claim underwriting decision lies with the Takaful Company. I further affirm that I have provided genuine responses, to the best of my knowledge, on all the details shared at the time of sale. I am aware that any incorrect information provided can adversely affect the claim decision",
      "I am aware claim intimation can be filed at the Takaful Company Head Office (address below) or any Takaful Company branch. Claims can also be lodged through Takaful Company's Call Centre or by filling out intimation form on their website and/or submission via email address given below.",
    ],
    contact: {
      company: "Jubilee General - Window Takaful Operations",
      address:
        "3rd Floor, Jubilee Insurance House, I.I Chundrigar Rd, City Railway Colony, Karachi, Karachi City, Sindh 74000",
    },
  };

  const urduContent = {
    title: "الفا مال محافظ تکافل جوبلی جنرل ۔ونڈو تکافل آپریشنز کی جانب سے",
    subtitle: "بیسک فیکٹ شیٹ",
    greeting: "محترم صارف،",
    intro:
      "تکافل پلان کا انتخاب ایک اہم فیصلہ ہے اور ہم آپ کے اس انتخاب پر آپ کے شکر گزار ہیں۔ ہم اس بات کو یقینی بنانا چاہتے ہیں کہ آپ اپنے اس انتخاب کے فوائد و نقصانات سے مکمل آگاہ ہوں۔ لہٰذا براہِ کرم درج ذیل تفصیلات پر توجہ دیں۔",
    description:
      '"الفا مال محافظ تکافل" جوبلی جنرل انشورنس کے تحت ونڈو تکافل آپریشنز کا ایک شریعہ کمپلائینٹ تکافل پلان ہے جو پلان میں شامل تکافل شدہ سامان کی غیر متوقع اور اچانک ہونے والے نقصانات اور توڑ پھوڑ کو مکمل تحفظ فراہم کرتا ہے۔ اس میں PS5، اسمارٹ واچز، پوڈز اور اسمارٹ فونز شامل ہیں۔',
    keyPoints: [
      "کسی بھی ابہام سے بچنے کے لیے، یہ ممبرشپ ایک خالص تکافل پروڈکٹ ہے جو بینک الفلاح لمیٹڈ کے ذریعے تقسیم کی جا رہی ہے، مگر مکمل طور پر تکافل کمپنی کی پروڈکٹ ہے۔ یہ کوئی بینکنگ پروڈکٹ نہیں ہے اور بینک الفلاح لمیٹڈ کسی بھی صورت میں ان پروڈکٹس کی کارکردگی یا تکافل کمپنی کی جانب سے کلیم کے پراسیسنگ یا مسترد کیے جانے کے نتیجے میں صارف کو ہونے والے کسی بھی نقصان کا ذمہ دار نہیں ہوگا۔",
      "میں تسلیم کرتا/کرتی ہوں اور تکافل کمپنی کو اپنے بنیادی اور ذاتی معلومات کے پراسیسنگ مقاصد کے لیے شیئر کرنے کی اجازت دیتا/دیتی ہوں۔",
      "میں سمجھتا /سمجھتی ہوں کہ اس پلان میں کوئی سرمایہ کاری شامل نہیں ہے اور اس کی رکنیت کی مدت صرف ایک سال ہے۔",
      "میں اس بات سے آگاہ ہوں کہ میرے بینک الفلاح اکاؤنٹ میں فروخت کے وقت کٹوتی کے لیے کافی فنڈز رکھنا مکمل طور پر میری ذمہ داری ہے۔",
      "اس پلان کے تحت فری لک پیریڈ 14 دن کا ہے، جو ممبرشپ کے دستاویزات کی وصولی کی تاریخ سے شروع ہوتا ہے۔ اس مدت کے دوران رکنیت منسوخ کی جا سکتی ہے اور صارف کو مکمل رقم واپس کر دی جائے گی۔",
      "آپ کسی بھی وقت اپنی ممبرشپ منسوخ کر سکتے ہیں، تاہم، 14 دن کے بعد کسی بھی صورت میں کنٹریبیوشن کی رقم واپس نہیں کی جائے گی۔ منسوخی کے لیے 111 225 111 پر رابطہ کریں یا الفا ایپ پر منسوخی کا اندراج کریں۔",
      "کلیم کی پراسیسنگ مکمل طور پر تکافل کمپنی کی ذمہ داری ہے۔ بینک الفلاح لمیٹڈ بطور تقسیم کار صرف کلیم جمع کرانے کے عمل میں سہولت فراہم کرے گا، تاہم کلیم کے انڈر رائٹنگ کا فیصلہ تکافل کمپنی کے اختیار میں ہوگا۔ میں مزید تصدیق کرتا/کرتی ہوں کہ فروخت کے وقت فراہم کی گئی تمام تفصیلات میرے علم کے مطابق درست ہیں۔ میں آگاہ ہوں کہ فراہم کردہ کوئی بھی غلط معلومات کلیم کے فیصلے پر منفی اثر ڈال سکتی ہیں۔",
      "میں آگاہ ہوں کہ کلیم کی اطلاع تکافل کمپنی کے ہیڈ آفس (درج ذیل پتے پر) یا کسی بھی تکافل کمپنی کی برانچ میں دی جا سکتی ہے۔ کلیم درج کرانے کے لیے تکافل کمپنی کے کال سینٹر سے بھی رابطہ کیا جا سکتا ہے یا ان کی ویب سائٹ پر موجود اطلاع فارم بھر کر یا درج ذیل ای میل ایڈریس پر بھیجا جا سکتا ہے۔",
    ],
    contact: {
      company: "جوبلی جنرل ۔ونڈو تکافل آپریشنز",
      address:
        "تیسری منزل، جوبلی انشورنس ہاؤس، آئی آئی چندریگر روڈ، سٹی ریلوے کالونی، کراچی، سندھ 74000",
    },
  };

  const currentContent = language === "english" ? englishContent : urduContent;
  const isRTL = language === "urdu";

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={600}
      footer={null}
      closable={false}
      centered
      bodyStyle={{
        padding: 0,
        borderRadius: "12px",
        overflow: "hidden",
        maxHeight: "80vh",
      }}
      style={{
        borderRadius: "12px",
      }}
    >
      <div
        style={{
          position: "relative",
          backgroundColor: "white",
          borderRadius: "12px",
          direction: isRTL ? "rtl" : "ltr",
        }}
      >
        {/* Header with Close Button and Language Switcher */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 20px",
            borderBottom: "1px solid #f0f0f0",
            backgroundColor: "#fafafa",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "14px", fontWeight: "500" }}>
              {language === "english" ? "Language:" : "زبان:"}
            </span>
            <Switch
              checkedChildren="اردو"
              unCheckedChildren="EN"
              checked={language === "urdu"}
              onChange={(checked) => setLanguage(checked ? "urdu" : "english")}
              style={{
                backgroundColor: language === "urdu" ? "#52c41a" : "red",
              }}
            />
          </div>

          <Button
            type="text"
            icon={<CloseOutlined style={{ color: "#666", fontSize: "16px" }} />}
            onClick={onClose}
            style={{
              borderRadius: "50%",
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #d9d9d9",
              padding: 0,
            }}
          />
        </div>

        {/* Content */}
        <div
          style={{
            maxHeight: "60vh",
            overflowY: "auto",
            padding: "20px",
          }}
        >
          {/* Title */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <h2
              style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "8px",
                lineHeight: "1.4",
              }}
            >
              {currentContent.title}
            </h2>
            <div
              style={{
                color: "#e74c3c",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {currentContent.subtitle}
            </div>
          </div>

          {/* Main Content */}
          <div style={{ fontSize: "14px", lineHeight: "1.6", color: "#333" }}>
            <p style={{ fontWeight: "600", marginBottom: "12px" }}>
              {currentContent.greeting}
            </p>

            <p style={{ marginBottom: "16px", textAlign: "justify" }}>
              {currentContent.intro}
            </p>

            <p style={{ marginBottom: "16px", textAlign: "justify" }}>
              {currentContent.description}
            </p>

            {/* Key Points */}
            <div style={{ marginBottom: "20px" }}>
              <ol
                style={{
                  paddingLeft: isRTL ? "0" : "20px",
                  paddingRight: isRTL ? "20px" : "0",
                }}
              >
                {currentContent.keyPoints.map((point, index) => (
                  <li
                    key={index}
                    style={{ marginBottom: "8px", textAlign: "justify" }}
                  >
                    {point}
                  </li>
                ))}
              </ol>
            </div>

            {/* Contact Information */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "16px",
                borderRadius: "8px",
                border: "1px solid #e9ecef",
                marginBottom: "20px",
              }}
            >
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                {language === "english" ? "Takaful Company:" : "تکافل کمپنی:"}
              </div>
              <div style={{ marginBottom: "8px" }}>
                {currentContent.contact.company}
              </div>
              <div style={{ fontSize: "13px", color: "#666" }}>
                {currentContent.contact.address}
              </div>
            </div>

            {/* Important Note */}
            <div
              style={{
                backgroundColor: "#fff3cd",
                padding: "12px",
                borderRadius: "6px",
                border: "1px solid #ffeaa7",
                fontSize: "13px",
                color: "#856404",
              }}
            >
              <strong>
                {language === "english"
                  ? "Note: Please read all terms & conditions carefully before proceeding."
                  : "نوٹ: آگے بڑھنے سے پہلے تمام شرائط و ضوابط کو غور سے پڑھیں۔"}
              </strong>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "20px",
            backgroundColor: "#fafafa",
            borderTop: "1px solid #f0f0f0",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            type="primary"
            onClick={onAccept}
            style={{
              backgroundColor: "#e74c3c",
              borderColor: "#e74c3c",
              borderRadius: "6px",
              padding: "8px 40px",
              height: "auto",
              fontSize: "16px",
              fontWeight: "600",
              boxShadow: "0 2px 8px rgba(231, 76, 60, 0.3)",
            }}
          >
            {language === "english" ? "I Agree" : "میں متفق ہوں"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default InsuranceTermsModal;
